import settings from '@solinkcorp/settings';

export default {
  getPlayList: async (url: string) => {
    try {
      const response = await fetch(url, {
        credentials: 'include',
        method: 'GET',
      });
      return await response.text();
    } catch (err) {
      return { err };
    }
  },
  getAlarmPlayList: async (url: string) => {
    const config: RequestInit = {
      credentials: 'include',
      method: 'GET',
    };

    try {
      const response = await fetch(url, config);
      return await response.text();
    } catch (err) {
      return { err };
    }
  },

  parseToken: async (token = '') => {
    const url = `${settings.publicCloudVmsHost}/share/${encodeURIComponent(token)}`;
    try {
      const res = await fetch(url);
      if (!res.ok) {
        throw new Error(`An error occurred while fetching the data. Status: ${res.status}`);
      }
      return await res.json();
    } catch (err) {
      const { message } = err as Error;
      throw new Error(`An error occurred while fetching the data. ${message}`);
    }
  },

  headCheck: async (url: string) => {
    try {
      const response = await fetch(url, {
        credentials: 'include',
        method: 'HEAD',
      });
      if (response.ok) {
        return true;
      }
      return false;
    } catch (err) {
      console.error(err);
      return false;
    }
  },

  getVttFile: async (url: string) => {
    try {
      const headers = new Headers();
      headers.append('pragma', 'no-cache');
      headers.append('cache-control', 'no-cache');
      const response = await fetch(url, {
        credentials: 'include',
        method: 'GET',
        headers,
      });
      return await response.text();
    } catch (err) {
      console.error(err);
      return { err };
    }
  },
};
